(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_s2_s2_automate_dsl.js', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_s2_s2_automate_dsl.js'), require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_city_smartb_s2_s2_automate_dsl === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_protocol_domain'. Its dependency 'kotlin_city_smartb_s2_s2_automate_dsl' was not found. Please, check whether 'kotlin_city_smartb_s2_s2_automate_dsl' is loaded prior to 'kotlin_org_axessimpact_protocol_domain'.");
    }
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_protocol_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_axessimpact_protocol_domain'.");
    }
    root.kotlin_org_axessimpact_protocol_domain = factory(typeof kotlin_org_axessimpact_protocol_domain === 'undefined' ? {} : kotlin_org_axessimpact_protocol_domain, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin);
  }
}(this, function (_, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin) {
  //region block: imports
  var imul = Math.imul;
  var S2Role = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Role;
  var S2State = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2State;
  var S2Command = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Command;
  var S2InitCommand = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitCommand;
  var S2Event = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Event;
  var S2InitTransitionBuilder = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitTransitionBuilder;
  var getKClass = kotlin_kotlin.$crossModule$.getKClass;
  var S2Transition = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Transition;
  var Unit_getInstance = kotlin_kotlin.$crossModule$.Unit_getInstance;
  var S2TransitionBuilder = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2TransitionBuilder;
  var s2 = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.s2;
  var getStringHashCode = kotlin_kotlin.$crossModule$.getStringHashCode;
  var THROW_CCE = kotlin_kotlin.$crossModule$.THROW_CCE;
  var hashCode = kotlin_kotlin.$crossModule$.hashCode;
  var equals = kotlin_kotlin.$crossModule$.equals;
  var getNumberHashCode = kotlin_kotlin.$crossModule$.getNumberHashCode;
  //endregion
  'use strict';
  //region block: pre-declaration
  Created.prototype = Object.create(ProtocolState.prototype);
  Created.prototype.constructor = Created;
  //endregion
  function _get_S2Protocol__3754475892() {
    init_properties_S2Protocol_kt_1148898723();
    return S2Protocol;
  }
  var S2Protocol;
  function s2Protocol() {
    init_properties_S2Protocol_kt_1148898723();
    return _get_S2Protocol__3754475892();
  }
  function Admin() {
  }
  Admin.$metadata$ = {
    simpleName: 'AdminRole',
    kind: 'class',
    interfaces: [S2Role]
  };
  function Created() {
    Created_instance = this;
    ProtocolState.call(this, 0);
  }
  Created.$metadata$ = {
    simpleName: 'Created',
    kind: 'object',
    interfaces: []
  };
  var Created_instance;
  function Created_getInstance() {
    if (Created_instance == null)
      new Created();
    return Created_instance;
  }
  function ProtocolState(position) {
    this.position_1 = position;
  }
  ProtocolState.prototype._set_position__3963083214_ves4de_k$ = function (_set____804775014) {
    this.position_1 = _set____804775014;
  };
  ProtocolState.prototype._get_position__3188952002_iahqv2_k$ = function () {
    return this.position_1;
  };
  ProtocolState.prototype.equals = function (other) {
    var tmp;
    if (other instanceof ProtocolState) {
      tmp = other.position === this.position;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  ProtocolState.prototype.hashCode = function () {
    return this.position;
  };
  ProtocolState.$metadata$ = {
    simpleName: 'ProtocolState',
    kind: 'class',
    interfaces: [S2State]
  };
  Object.defineProperty(ProtocolState.prototype, 'position', {
    configurable: true,
    get: function () {
      return this._get_position__3188952002_iahqv2_k$();
    },
    set: function (value) {
      this._set_position__3963083214_ves4de_k$(value);
    }
  });
  function ProtocolCommand() {
  }
  ProtocolCommand.$metadata$ = {
    simpleName: 'ProtocolCommand',
    kind: 'interface',
    interfaces: [S2Command]
  };
  function ProtocolInitCommand() {
  }
  ProtocolInitCommand.$metadata$ = {
    simpleName: 'ProtocolInitCommand',
    kind: 'interface',
    interfaces: [S2InitCommand]
  };
  function ProtocolEvent() {
  }
  ProtocolEvent.$metadata$ = {
    simpleName: 'ProtocolEvent',
    kind: 'interface',
    interfaces: [S2Event]
  };
  function S2Protocol$lambda() {
    return function ($this$s2) {
      $this$s2._set_name__589551916_2ji656_k$('ProtocolS2');
      var builder_1 = new S2InitTransitionBuilder();
      {
        builder_1._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$0;
      $l$block: {
        var tmp0_to_3 = builder_1._get_to__1413131888_ndcbjk_k$();
        var tmp1_role_4 = builder_1._get_role__808279189_dd887p_k$();
        var tmp0_let_0_2 = new S2Transition(null, tmp0_to_3, tmp1_role_4, getKClass(ProtocolCreateCommand));
        var tmp1_let_5 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$0 = tmp1_let_5.add_1j60pz_k$(tmp0_let_0_2);
        break $l$block;
      }
      Unit_getInstance();
      var builder_1_0 = new S2TransitionBuilder();
      {
        builder_1_0._set_from__582672365_yh8l08_k$(Created_getInstance());
        builder_1_0._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1_0._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$1;
      $l$block_0: {
        var tmp0_let_0_2_0 = new S2Transition(builder_1_0._get_from__797289441_d6oogx_k$(), builder_1_0._get_to__1413131888_ndcbjk_k$(), builder_1_0._get_role__808279189_dd887p_k$(), getKClass(ProtocolEvaluateCommand));
        var tmp1_let_3 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$1 = tmp1_let_3.add_1j60pz_k$(tmp0_let_0_2_0);
        break $l$block_0;
      }
      Unit_getInstance();
      var builder_1_1 = new S2TransitionBuilder();
      {
        builder_1_1._set_from__582672365_yh8l08_k$(Created_getInstance());
        builder_1_1._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1_1._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$2;
      $l$block_1: {
        var tmp0_let_0_2_1 = new S2Transition(builder_1_1._get_from__797289441_d6oogx_k$(), builder_1_1._get_to__1413131888_ndcbjk_k$(), builder_1_1._get_role__808279189_dd887p_k$(), getKClass(ProtocolValidateCommand));
        var tmp1_let_3_0 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$2 = tmp1_let_3_0.add_1j60pz_k$(tmp0_let_0_2_1);
        break $l$block_1;
      }
      Unit_getInstance();
      var builder_1_2 = new S2TransitionBuilder();
      {
        builder_1_2._set_from__582672365_yh8l08_k$(Created_getInstance());
        builder_1_2._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1_2._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$3;
      $l$block_2: {
        var tmp0_let_0_2_2 = new S2Transition(builder_1_2._get_from__797289441_d6oogx_k$(), builder_1_2._get_to__1413131888_ndcbjk_k$(), builder_1_2._get_role__808279189_dd887p_k$(), getKClass(ProtocolConsumeQuantityCommand));
        var tmp1_let_3_1 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$3 = tmp1_let_3_1.add_1j60pz_k$(tmp0_let_0_2_2);
        break $l$block_2;
      }
      Unit_getInstance();
      return Unit_getInstance();
    };
  }
  var properties_initialized_S2Protocol_kt_2589455303;
  function init_properties_S2Protocol_kt_1148898723() {
    if (!properties_initialized_S2Protocol_kt_2589455303) {
      properties_initialized_S2Protocol_kt_2589455303 = true;
      S2Protocol = s2(S2Protocol$lambda());
    }
  }
  function ProtocolConsumeQuantityCommand(id, quantity) {
    this.id_1 = id;
    this.quantity_1 = quantity;
  }
  ProtocolConsumeQuantityCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProtocolConsumeQuantityCommand.prototype.toString = function () {
    return 'ProtocolConsumeQuantityCommand(id=' + this.id_1 + ', quantity=' + this.quantity_1 + ')';
  };
  ProtocolConsumeQuantityCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + this.quantity_1 | 0;
    return result;
  };
  ProtocolConsumeQuantityCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtocolConsumeQuantityCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProtocolConsumeQuantityCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.quantity_1 === tmp0_other_with_cast.quantity_1))
      return false;
    return true;
  };
  ProtocolConsumeQuantityCommand.$metadata$ = {
    simpleName: 'ProtocolConsumeQuantityCommand',
    kind: 'class',
    interfaces: [ProtocolCommand]
  };
  Object.defineProperty(ProtocolConsumeQuantityCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  function ProtocolCreateCommandDTO() {
  }
  ProtocolCreateCommandDTO.$metadata$ = {
    simpleName: 'ProtocolCreateCommandDTO',
    kind: 'interface',
    interfaces: [ProtocolInitCommand]
  };
  function ProtocolCreatedEventDTO() {
  }
  ProtocolCreatedEventDTO.$metadata$ = {
    simpleName: 'ProtocolCreatedEventDTO',
    kind: 'interface',
    interfaces: [ProtocolEvent]
  };
  function ProtocolCreateCommand(projectId, sdgList, sector, name, description, typeId, quantity) {
    this.projectId_1 = projectId;
    this.sdgList_1 = sdgList;
    this.sector_1 = sector;
    this.name_1 = name;
    this.description_1 = description;
    this.typeId_1 = typeId;
    this.quantity_1 = quantity;
  }
  ProtocolCreateCommand.prototype._get_projectId__1017201341_gtm5kt_k$ = function () {
    return this.projectId_1;
  };
  ProtocolCreateCommand.prototype._get_sdgList__2264023965_xl65wj_k$ = function () {
    return this.sdgList_1;
  };
  ProtocolCreateCommand.prototype._get_sector__4255585381_ng3a3_k$ = function () {
    return this.sector_1;
  };
  ProtocolCreateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  ProtocolCreateCommand.prototype._get_description__4027823381_4f1tkb_k$ = function () {
    return this.description_1;
  };
  ProtocolCreateCommand.prototype._get_typeId__1432226742_nopl86_k$ = function () {
    return this.typeId_1;
  };
  ProtocolCreateCommand.prototype._get_quantity__301411488_4zgalc_k$ = function () {
    return this.quantity_1;
  };
  ProtocolCreateCommand.prototype.toString = function () {
    return 'ProtocolCreateCommand(projectId=' + this.projectId_1 + ', sdgList=' + this.sdgList_1 + ', sector=' + this.sector_1 + ', name=' + this.name_1 + ', description=' + this.description_1 + ', typeId=' + this.typeId_1 + ', quantity=' + this.quantity_1 + ')';
  };
  ProtocolCreateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.projectId_1);
    result = imul(result, 31) + hashCode(this.sdgList_1) | 0;
    result = imul(result, 31) + this.sector_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.description_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.typeId_1) | 0;
    result = imul(result, 31) + this.quantity_1 | 0;
    return result;
  };
  ProtocolCreateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtocolCreateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProtocolCreateCommand ? other : THROW_CCE();
    if (!(this.projectId_1 === tmp0_other_with_cast.projectId_1))
      return false;
    if (!equals(this.sdgList_1, tmp0_other_with_cast.sdgList_1))
      return false;
    if (!this.sector_1.equals(tmp0_other_with_cast.sector_1))
      return false;
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.description_1 === tmp0_other_with_cast.description_1))
      return false;
    if (!(this.typeId_1 === tmp0_other_with_cast.typeId_1))
      return false;
    if (!(this.quantity_1 === tmp0_other_with_cast.quantity_1))
      return false;
    return true;
  };
  ProtocolCreateCommand.$metadata$ = {
    simpleName: 'ProtocolCreateCommand',
    kind: 'class',
    interfaces: [ProtocolCreateCommandDTO]
  };
  Object.defineProperty(ProtocolCreateCommand.prototype, 'projectId', {
    configurable: true,
    get: function () {
      return this._get_projectId__1017201341_gtm5kt_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'sdgList', {
    configurable: true,
    get: function () {
      return this._get_sdgList__2264023965_xl65wj_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'sector', {
    configurable: true,
    get: function () {
      return this._get_sector__4255585381_ng3a3_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'description', {
    configurable: true,
    get: function () {
      return this._get_description__4027823381_4f1tkb_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'typeId', {
    configurable: true,
    get: function () {
      return this._get_typeId__1432226742_nopl86_k$();
    }
  });
  Object.defineProperty(ProtocolCreateCommand.prototype, 'quantity', {
    configurable: true,
    get: function () {
      return this._get_quantity__301411488_4zgalc_k$();
    }
  });
  function ProtocolEvaluateCommandDTO() {
  }
  ProtocolEvaluateCommandDTO.$metadata$ = {
    simpleName: 'ProtocolEvaluateCommandDTO',
    kind: 'interface',
    interfaces: [ProtocolCommand]
  };
  function ProtocolEvaluatedEventDTO() {
  }
  ProtocolEvaluatedEventDTO.$metadata$ = {
    simpleName: 'ProtocolEvaluatedEventDTO',
    kind: 'interface',
    interfaces: [ProtocolEvent]
  };
  function ProtocolEvaluateCommand(id, quantity, image, imageMoisture, imageTemperature) {
    this.id_1 = id;
    this.quantity_1 = quantity;
    this.image_1 = image;
    this.imageMoisture_1 = imageMoisture;
    this.imageTemperature_1 = imageTemperature;
  }
  ProtocolEvaluateCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProtocolEvaluateCommand.prototype._get_quantity__301411488_4zgalc_k$ = function () {
    return this.quantity_1;
  };
  ProtocolEvaluateCommand.prototype._get_image__3321984470_g3aecq_k$ = function () {
    return this.image_1;
  };
  ProtocolEvaluateCommand.prototype._get_imageMoisture__2765840630_paehoq_k$ = function () {
    return this.imageMoisture_1;
  };
  ProtocolEvaluateCommand.prototype._get_imageTemperature__1034213586_h3qsb6_k$ = function () {
    return this.imageTemperature_1;
  };
  ProtocolEvaluateCommand.prototype.toString = function () {
    return 'ProtocolEvaluateCommand(id=' + this.id_1 + ', quantity=' + this.quantity_1 + ', image=' + this.image_1 + ', imageMoisture=' + this.imageMoisture_1 + ', imageTemperature=' + this.imageTemperature_1 + ')';
  };
  ProtocolEvaluateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + this.quantity_1 | 0;
    result = imul(result, 31) + (this.image_1 == null ? 0 : getStringHashCode(this.image_1)) | 0;
    result = imul(result, 31) + (this.imageMoisture_1 == null ? 0 : getStringHashCode(this.imageMoisture_1)) | 0;
    result = imul(result, 31) + (this.imageTemperature_1 == null ? 0 : getStringHashCode(this.imageTemperature_1)) | 0;
    return result;
  };
  ProtocolEvaluateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtocolEvaluateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProtocolEvaluateCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.quantity_1 === tmp0_other_with_cast.quantity_1))
      return false;
    if (!(this.image_1 == tmp0_other_with_cast.image_1))
      return false;
    if (!(this.imageMoisture_1 == tmp0_other_with_cast.imageMoisture_1))
      return false;
    if (!(this.imageTemperature_1 == tmp0_other_with_cast.imageTemperature_1))
      return false;
    return true;
  };
  ProtocolEvaluateCommand.$metadata$ = {
    simpleName: 'ProtocolEvaluateCommand',
    kind: 'class',
    interfaces: [ProtocolEvaluateCommandDTO]
  };
  Object.defineProperty(ProtocolEvaluateCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(ProtocolEvaluateCommand.prototype, 'quantity', {
    configurable: true,
    get: function () {
      return this._get_quantity__301411488_4zgalc_k$();
    }
  });
  Object.defineProperty(ProtocolEvaluateCommand.prototype, 'image', {
    configurable: true,
    get: function () {
      return this._get_image__3321984470_g3aecq_k$();
    }
  });
  Object.defineProperty(ProtocolEvaluateCommand.prototype, 'imageMoisture', {
    configurable: true,
    get: function () {
      return this._get_imageMoisture__2765840630_paehoq_k$();
    }
  });
  Object.defineProperty(ProtocolEvaluateCommand.prototype, 'imageTemperature', {
    configurable: true,
    get: function () {
      return this._get_imageTemperature__1034213586_h3qsb6_k$();
    }
  });
  function ProtocolValidateCommandDTO() {
  }
  ProtocolValidateCommandDTO.$metadata$ = {
    simpleName: 'ProtocolValidateCommandDTO',
    kind: 'interface',
    interfaces: [ProtocolCommand]
  };
  function ProtocolValidatedEventDTO() {
  }
  ProtocolValidatedEventDTO.$metadata$ = {
    simpleName: 'ProtocolValidatedEventDTO',
    kind: 'interface',
    interfaces: [ProtocolEvent]
  };
  function ProtocolValidateCommand(id, quantity, price) {
    this.id_1 = id;
    this.quantity_1 = quantity;
    this.price_1 = price;
  }
  ProtocolValidateCommand.prototype._get_id__1413120976_ndc34g_k$ = function () {
    return this.id_1;
  };
  ProtocolValidateCommand.prototype._get_quantity__301411488_4zgalc_k$ = function () {
    return this.quantity_1;
  };
  ProtocolValidateCommand.prototype._get_price__3527240616_cp31p4_k$ = function () {
    return this.price_1;
  };
  ProtocolValidateCommand.prototype.toString = function () {
    return 'ProtocolValidateCommand(id=' + this.id_1 + ', quantity=' + this.quantity_1 + ', price=' + this.price_1 + ')';
  };
  ProtocolValidateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.id_1);
    result = imul(result, 31) + this.quantity_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.price_1) | 0;
    return result;
  };
  ProtocolValidateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtocolValidateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof ProtocolValidateCommand ? other : THROW_CCE();
    if (!(this.id_1 === tmp0_other_with_cast.id_1))
      return false;
    if (!(this.quantity_1 === tmp0_other_with_cast.quantity_1))
      return false;
    if (!equals(this.price_1, tmp0_other_with_cast.price_1))
      return false;
    return true;
  };
  ProtocolValidateCommand.$metadata$ = {
    simpleName: 'ProtocolValidateCommand',
    kind: 'class',
    interfaces: [ProtocolValidateCommandDTO]
  };
  Object.defineProperty(ProtocolValidateCommand.prototype, 'id', {
    configurable: true,
    get: function () {
      return this._get_id__1413120976_ndc34g_k$();
    }
  });
  Object.defineProperty(ProtocolValidateCommand.prototype, 'quantity', {
    configurable: true,
    get: function () {
      return this._get_quantity__301411488_4zgalc_k$();
    }
  });
  Object.defineProperty(ProtocolValidateCommand.prototype, 'price', {
    configurable: true,
    get: function () {
      return this._get_price__3527240616_cp31p4_k$();
    }
  });
  function ProtocolDetailsDTO() {
  }
  ProtocolDetailsDTO.$metadata$ = {
    simpleName: 'ProtocolDetailsDTO',
    kind: 'interface',
    interfaces: []
  };
  function ProtocolImageDTO() {
  }
  ProtocolImageDTO.$metadata$ = {
    simpleName: 'ProtocolImageDTO',
    kind: 'interface',
    interfaces: []
  };
  function SdgDTO() {
  }
  SdgDTO.$metadata$ = {
    simpleName: 'SdgDTO',
    kind: 'interface',
    interfaces: []
  };
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    $org$axess$s2$protocol$domain.s2Protocol = s2Protocol;
    $org$axess$s2$protocol$domain.Admin = Admin;
    $org$axess$s2$protocol$domain.ProtocolState = ProtocolState;
    Object.defineProperty($org$axess$s2$protocol$domain.ProtocolState, 'Created', {
      configurable: true,
      get: Created_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$features = $org$axess$s2$protocol$domain.features || ($org$axess$s2$protocol$domain.features = {});
    var $org$axess$s2$protocol$domain$features$command = $org$axess$s2$protocol$domain$features.command || ($org$axess$s2$protocol$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$features = $org$axess$s2$protocol$domain.features || ($org$axess$s2$protocol$domain.features = {});
    var $org$axess$s2$protocol$domain$features$command = $org$axess$s2$protocol$domain$features.command || ($org$axess$s2$protocol$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$features = $org$axess$s2$protocol$domain.features || ($org$axess$s2$protocol$domain.features = {});
    var $org$axess$s2$protocol$domain$features$command = $org$axess$s2$protocol$domain$features.command || ($org$axess$s2$protocol$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$model = $org$axess$s2$protocol$domain.model || ($org$axess$s2$protocol$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$model = $org$axess$s2$protocol$domain.model || ($org$axess$s2$protocol$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$protocol = $org$axess$s2.protocol || ($org$axess$s2.protocol = {});
    var $org$axess$s2$protocol$domain = $org$axess$s2$protocol.domain || ($org$axess$s2$protocol.domain = {});
    var $org$axess$s2$protocol$domain$model = $org$axess$s2$protocol$domain.model || ($org$axess$s2$protocol$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_protocol_domain.js.map